import * as React from "react";
import { AccessRightCodes } from "Components/Models/AccessRights";
import { useHasCurrentUserAccessRight } from "Hooks/useHasCurrentUserAccessRight";

type Props = {
  accessRights: AccessRightCodes[];
};

export const Authorized: React.FunctionComponent<Props> = props => {
  const { accessRights, children } = props;
  const hasAccessRight = useHasCurrentUserAccessRight();

  const hasAccess = () => {
    return hasAccessRight(accessRights);
  };

  return <>{hasAccess() && children}</>;
};
